import { inject, Injectable } from '@angular/core';
import { PasswordModalStore } from './password-modal.store';
import { finalize } from 'rxjs';
import { SessionFacade } from '../../core/auth/facades/session.facade';

@Injectable()
export class PasswordModalFacade {
  readonly #sessionFacade = inject(SessionFacade);
  readonly #passwordModalStore = inject(PasswordModalStore);

  login(username: string, password?: string) {
    this.#passwordModalStore.updateIsLoading(true);

    return this.#sessionFacade
      .login({
        username,
        password
      })
      .pipe(finalize(() => this.#passwordModalStore.updateIsLoading(false)));
  }
}
